import { db } from "../../firebase";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAt,
  where,
} from "firebase/firestore";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

import { getAuth } from "firebase/auth";

const GetProperties = async (
  uid,
  Type = "*",
  SkipCount = 0,
  LimitCount = 8
) => {
  /**
   * input: null
   * output: properties object
  iption: fetches All properties
   */
  try {
    let firstDocSnapshot = await getFirstDocSnapshot(Type, SkipCount);

    const PropertiesCollection = await collection(db, "properties");
    let q;

    let _spread = [
      where("bid", "==", getLocalStorageItem("bid")),
      limit(LimitCount),
      orderBy("createdAt", "desc"),
      startAt(firstDocSnapshot ?? ""),
    ];

    if (getLocalStorageItem("permissions") !== "all")
      _spread = [
        ..._spread,
        where("createdBy", "==", getAuth()?.currentUser.uid),
      ];

    if (Type === "*") {
      q = query(PropertiesCollection, ..._spread);
    } else if (Type === "rent") {
      q = query(
        PropertiesCollection,
        where("availableForRent", "==", true),
        ..._spread
      );
    } else if (Type === "buy") {
      q = query(
        PropertiesCollection,
        where("availableForSale", "==", true),
        ..._spread
      );
    }
    const PropertiesSnapshot = await getDocs(q);
    let Properties = [];
    PropertiesSnapshot.forEach((e) =>
      Properties.push({ ...e.data(), id: e.id })
    );
    return Properties;
  } catch (error) {
    console.log(error);
    return [];
  }
};

const getFirstDocSnapshot = async (Type, SkipCount) => {
  try {
    const PropertiesCollection = await collection(db, "properties");
    let q;

    if (Type === "*") {
      q = query(
        PropertiesCollection,
        where("bid", "==", getLocalStorageItem("bid")),
        limit(SkipCount + 1),
        orderBy("createdAt", "desc")
      );
    } else if (Type === "rent") {
      q = query(
        PropertiesCollection,
        where("bid", "==", getLocalStorageItem("bid")),
        where("availableForRent", "==", true),
        limit(SkipCount + 1),
        orderBy("createdAt", "desc")
      );
    } else if (Type === "buy") {
      q = query(
        PropertiesCollection,
        where("bid", "==", getLocalStorageItem("bid")),
        where("availableForSale", "==", true),
        limit(SkipCount + 1),
        orderBy("createdAt", "desc")
      );
    }

    const PropertiesSnapshot = await getDocs(q);
    return PropertiesSnapshot.docs[SkipCount];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export default GetProperties;
